import { createAction, props } from '@ngrx/store';
import { IAuthUserEntitlementsResponse } from '../services/entitlements-api-queries';

/************************************************************************
 *  ENTITLEMENTS ACTIONS
 ************************************************************************/
export const setUserEntitlements = createAction('[Entitlements] Set User Entitlements', props<IAuthUserEntitlementsResponse>());

export const getUserEntitlementsError = createAction('[Entitlements] Get User Entitlements');
